module.exports = __webpack_public_path__ + "static/media/secure-icon.e96b2d17.svg";